/**
 * Central config for the Help & Support page: the support contact + form options
 * + small helpers. Kept in one place so the support address and categories are a
 * one-line change.
 *
 * NOTE: `support@yourdisclosure.com` should be provisioned as a shared/monitored
 * mailbox (O365) — it intentionally replaces the founder's personal email as the
 * support contact. Until a backend support-intake endpoint exists, the forms
 * submit via a prefilled mailto (see `submitViaEmail`); swapping to an API later
 * only changes that one helper, not the forms.
 */
export const SUPPORT_EMAIL = "support@yourdisclosure.com";

export const SUPPORT_CATEGORIES = [
  "Question / how-to",
  "Something isn't working (bug)",
  "Account or access",
  "Data or privacy",
  "Feature request",
  "Other",
];

export const FEEDBACK_TYPES = [
  "Idea / suggestion",
  "Something's confusing",
  "Praise",
  "Other",
];

/** Safely read the signed-in user from localStorage (used to prefill forms). */
export const getCurrentUser = () => {
  try {
    return JSON.parse(localStorage.getItem("user")) || {};
  } catch {
    return {};
  }
};

export const userDisplayName = (u = {}) =>
  [u.firstName, u.lastName].filter(Boolean).join(" ") ||
  u.name ||
  u.userName ||
  "";

export const userEmail = (u = {}) => u.email || u.userName || "";

/**
 * Build a mailto: URL with a structured, prefilled body. This is the working
 * submission channel today. To move to a backend intake later, replace the body
 * of `submitViaEmail` with an API POST — the form components don't change.
 */
export const submitViaEmail = (subject, body) => {
  const url = `mailto:${SUPPORT_EMAIL}?subject=${encodeURIComponent(
    subject
  )}&body=${encodeURIComponent(body)}`;
  window.location.href = url;
};
